export const NAME = 'releseNotification';
